import { saveModelPaidLimit, useModelSpend } from "../../state/modelSpend";
import { PaidUsageLimitForm } from "./PaidUsageLimitForm";

export { parsePaidLimit } from "./PaidUsageLimitForm";

export function PaidUsageLimit({ organizationId }: { organizationId: string | null }) {
  const { status, refresh } = useModelSpend(organizationId);
  if (
    !status ||
    status.paidLimitGbp === undefined ||
    status.includedGbp === null ||
    status.state === "unknown"
  )
    return null;
  return (
    <PaidUsageLimitForm
      key={`${status.organizationId}:${status.userId}`}
      status={status}
      onSave={async (amount) => {
        const error = await saveModelPaidLimit(status.organizationId, status.userId, amount);
        if (!error) refresh();
        return error;
      }}
    />
  );
}
